import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { SidebarProvider } from '@/components/ui/sidebar';

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
  beforeLoad: async ({ location, context }) => {
    if (!context.auth?.session) {
      throw redirect({
        to: '/sign-in',
        search: {
          redirect: location.href,
        },
      });
    }

    if (!context.auth.user.emailVerified) {
      throw redirect({
        to: '/verify-email',
        search: {
          redirect: location.href,
        },
      });
    }

    return {
      activeOrganizationId: context.auth.session.activeOrganizationId,
    };
  },
});

function AuthenticatedLayout() {
  return (
    <SidebarProvider>
      <Outlet />
    </SidebarProvider>
  );
}
